<template>
  <div>
    <h2 class="top_title">数据总览</h2>
    <div class="contain">
      <aside>
        <div class="div_box">
          <div class="aside_top" @click="choosePage('首页')">
            <div class="text">首页</div>
            <div class="demo-date-picker">
              <el-date-picker
                style="width: 140px; position: absolute; right: 0px; top: 10px;"
                v-model="date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间"
                @change="getIndexList()"
              />
            </div>
          </div>
          <div class="aside_bottom">
            <div class="div_text">
              <div class="text_center">
                <div>{{ indexList.page_visit_uv }}</div>
                <div>总用户</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ indexList.page_visit_pv }}</div>
                <div>点击次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ indexList.page_staytime_pv }}</div>
                <div>浏览时长</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ indexList.entrypage_pv }}</div>
                <div>进入次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ indexList.exitpage_pv }}</div>
                <div>退出次数</div>
              </div>
            </div>
          </div>
        </div>
        <div class="div_box">
          <div class="aside_top" @click="choosePage('二手房主页')">
            <div class="text">二手房主页</div>
            <div class="demo-date-picker">
              <el-date-picker
                style="width: 140px; position: absolute; right: 0px; top: 10px;"
                v-model="sec_date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间"
                @change="getSecList()"
              />
            </div>
          </div>
          <div class="aside_bottom">
            <div class="div_text">
              <div class="text_center">
                <div>{{ secHouseList.page_visit_uv }}</div>
                <div>总用户</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ secHouseList.page_visit_pv }}</div>
                <div>点击次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ secHouseList.page_staytime_pv }}</div>
                <div>浏览时长</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ secHouseList.entrypage_pv }}</div>
                <div>进入次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ secHouseList.exitpage_pv }}</div>
                <div>退出次数</div>
              </div>
            </div>
          </div>
        </div>
        <div class="div_box">
          <div class="aside_top" @click="choosePage('热点')">
            <div class="text">热点</div>
            <div class="demo-date-picker">
              <el-date-picker
                style="width: 140px; position: absolute; right: 0px; top: 10px;"
                v-model="spot_date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间"
                @change="getSpotList()"
              />
            </div>
          </div>
          <div class="aside_bottom">
            <div class="div_text">
              <div class="text_center">
                <div>{{ spotList.page_visit_uv }}</div>
                <div>总用户</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ spotList.page_visit_pv }}</div>
                <div>点击次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ spotList.page_staytime_pv }}</div>
                <div>浏览时长</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ spotList.entrypage_pv }}</div>
                <div>进入次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ spotList.exitpage_pv }}</div>
                <div>退出次数</div>
              </div>
            </div>
          </div>
        </div>
        <div class="div_box">
          <div class="aside_top" @click="choosePage('新房楼盘主页面')">
            <div class="text">新房楼盘主页面</div>
            <div class="demo-date-picker">
              <el-date-picker
                style="width: 140px; position: absolute; right: 0px; top: 10px;"
                v-model="new_date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间"
                @change="getNewList()"
              />
            </div>
          </div>
          <div class="aside_bottom">
            <div class="div_text">
              <div class="text_center">
                <div>{{ newList.page_visit_uv }}</div>
                <div>总用户</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ newList.page_visit_pv }}</div>
                <div>点击次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ newList.page_staytime_pv }}</div>
                <div>浏览时长</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ newList.entrypage_pv }}</div>
                <div>进入次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ newList.exitpage_pv }}</div>
                <div>退出次数</div>
              </div>
            </div>
          </div>
        </div>
        <div class="div_box">
          <div class="aside_top" @click="choosePage('二手房楼盘主页面')">
            <div class="text">二手房楼盘主页面</div>
            <div class="demo-date-picker">
              <el-date-picker
                style="width: 140px; position: absolute; right: 0px; top: 10px;"
                v-model="estate_date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间"
                @change="getSecEstateList()"
              />
            </div>
          </div>
          <div class="aside_bottom">
            <div class="div_text">
              <div class="text_center">
                <div>{{ secEstateList.page_visit_uv }}</div>
                <div>总用户</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ secEstateList.page_visit_pv }}</div>
                <div>点击次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ secEstateList.page_staytime_pv }}</div>
                <div>浏览时长</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ secEstateList.entrypage_pv }}</div>
                <div>进入次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ secEstateList.exitpage_pv }}</div>
                <div>退出次数</div>
              </div>
            </div>
          </div>
        </div>
        <div class="div_box">
          <div class="aside_top" @click="choosePage('我的')">
            <div class="text">我的</div>
            <div class="demo-date-picker">
              <el-date-picker
                style="width: 140px; position: absolute; right: 0px; top: 10px;"
                v-model="user_date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间"
                @change="getUserList()"
              />
            </div>
          </div>
          <div class="aside_bottom">
            <div class="div_text">
              <div class="text_center">
                <div>{{ userList.page_visit_uv }}</div>
                <div>总用户</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ userList.page_visit_pv }}</div>
                <div>点击次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ userList.page_staytime_pv }}</div>
                <div>浏览时长</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ userList.entrypage_pv }}</div>
                <div>进入次数</div>
              </div>
            </div>
            <div class="div_text">
              <div class="text_center">
                <div>{{ userList.exitpage_pv }}</div>
                <div>退出次数</div>
              </div>
            </div>
          </div>
        </div>
      </aside>
      <div class="right_content">
        <div style="display: flex; margin-top: 10px;">
          <el-button
            class="button"
            @click="getDate('昨日')"
            :style="{
              backgroundColor: isActive ? '#ecf5ff' : '#fff',
              color: isActive ? '#40a9ff' : '#606266'
            }"
            >昨日</el-button
          >
          <el-button
            class="button"
            @click="getDate('七天')"
            :style="{
              backgroundColor: isActive1 ? '#ecf5ff' : '#fff',
              color: isActive1 ? '#40a9ff' : '#606266'
            }"
            >七天</el-button
          >
          <el-button
            class="button"
            @click="getDate('30天')"
            :style="{
              backgroundColor: isActive2 ? '#ecf5ff' : '#fff',
              color: isActive2 ? '#40a9ff' : '#606266'
            }"
            >30天</el-button
          >
          <!-- <div style="margin-left: 30px;">
            <el-date-picker
              style="width: 140px;"
              v-model="chooseDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              @change="changePage()"
            />
          </div> -->
          <el-input
            v-model="input"
            style="width: 150px; margin-left: 30px;"
            placeholder="输入名称筛选"
          />
          <el-button type="primary" style="margin-left: 10px;" @click="select()"
            >筛选</el-button
          >
        </div>
        <div class="container" ref="tableContainer">
          <el-table
            :data="tableData"
            :height="tabelHeight"
            @cell-click="handleCellClick"
          >
            <el-table-column
              prop="page_name"
              label="页面"
              width="250"
              sortable
            />
            <el-table-column
              prop="page_visit_uv"
              label="总用户"
              width="210"
              sortable
            />
            <el-table-column
              prop="page_visit_pv"
              label="点击次数"
              width="210"
              sortable
            />
            <el-table-column
              prop="page_staytime_pv"
              label="浏览时长"
              width="210"
              sortable
              :sort-method="sortNumberString"
            />
            <el-table-column
              prop="entrypage_pv"
              label="进入页面次数"
              width="210"
              sortable
            />
            <el-table-column prop="exitpage_pv" label="退出页面次数" sortable />
          </el-table>
          <div
            class="echarts"
            v-if="realAllList.length != 0"
            :style="{ display: isShow == true ? '' : 'none' }"
          >
            <L-echart
              :data="realAllList"
              :date="dateList"
              :title="title"
            ></L-echart>
          </div>
          <el-button
            class="selectPic"
            :style="{ display: isShow == true ? '' : 'none' }"
            v-if="realAllList.length != 0"
            @click="selectPic()"
            >收起图表
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LEchart from "../components/echarts_sec.vue";
export default {
  components: { LEchart },
  data() {
    return {
      indexList: [], //首页
      secHouseList: [], //二手房首页
      spotList: [], //热点
      newList: [], //新房楼盘主页面
      secEstateList: [], //二手楼盘主页面
      userList: [], //用户-我的
      tableData: [], //表格
      realAllList: [], // 筛选后传到L-echart组件的折线点数据
      dateList: [], // 时间数据
      date: "",
      date1: "",
      sec_date: "",
      spot_date: "",
      estate_date: "",
      new_date: "",
      user_date: "",
      input: "",
      tabelHeight: 0, //表格高度
      time: "",
      start_time: "",
      end_time: "",
      chooseDate: "",
      title: "", // L-echart组件标题
      allLists: [],
      chooseIndex: "", //选择的主页面
      isShow: true,
      isActive: false, //按钮按下
      isActive1: false,
      isActive2: false
    };
  },
  mounted() {
    this.getIndexList();
    this.getSecList();
    this.getSpotList();
    this.getNewList();
    this.getSecEstateList();
    this.getUserList();
    this.getAllPage();
    this.$nextTick(() => {
      this.count();
    });
  },
  methods: {
    count() {
      if (this.realAllList.length == 0) {
        const containerHeight = this.$refs.tableContainer.clientHeight;
        const percentage = 95;
        this.tabelHeight = (containerHeight * percentage) / 100;
        console.log(this.tabelHeight);
      } else {
        const containerHeight = this.$refs.tableContainer.clientHeight;
        const percentage = 60;
        this.tabelHeight = (containerHeight * percentage) / 100;
        console.log(this.tabelHeight);
      }
    },
    //选择主要页面，加载右部分功能流量
    choosePage(page) {
      console.log(page);
      if (page == "首页") {
        this.chooseIndex = "首页";
        this.getPage();
      } else if (page == "二手房主页") {
        this.chooseIndex = "二手房主页";
        this.getPage();
      } else if (page == "热点") {
        this.chooseIndex = "热点";
        this.getPage();
      } else if (page == "新房楼盘主页面") {
        this.chooseIndex = "新房楼盘主页面";
        this.getPage();
      } else if (page == "二手房楼盘主页面") {
        this.chooseIndex = "二手房楼盘主页面";
        this.getPage();
      } else if (page == "我的") {
        this.chooseIndex = "我的";
        this.getPage();
      }
    },
    //首页
    getIndexList() {
      this.$axios
        .get(this.$url_prefix + "getDataInfo", {
          params: {
            date: this.date
          }
        })
        .then(res => {
          this.indexList = res.data.data[0];
        });
    },
    //二手房主页
    getSecList() {
      this.$axios
        .get(this.$url_prefix + "getSecIndex", {
          params: {
            date: this.sec_date
          }
        })
        .then(res => {
          this.secHouseList = res.data.data[0];
        });
    },
    //热点
    getSpotList() {
      this.$axios
        .get(this.$url_prefix + "getSpotInfo", {
          params: {
            date: this.spot_date
          }
        })
        .then(res => {
          this.spotList = res.data.data[0];
        });
    },
    //新房楼盘主页面
    getNewList() {
      this.$axios
        .get(this.$url_prefix + "getNewInfo", {
          params: {
            date: this.new_date
          }
        })
        .then(res => {
          this.newList = res.data.data[0];
        });
    },
    //二手房楼盘主页面
    getSecEstateList() {
      this.$axios
        .get(this.$url_prefix + "getSecEstateInfo", {
          params: {
            date: this.estate_date
          }
        })
        .then(res => {
          this.secEstateList = res.data.data[0];
        });
    },
    //我的
    getUserList() {
      this.$axios
        .get(this.$url_prefix + "getUserDataInfo", {
          params: {
            date: this.user_date
          }
        })
        .then(res => {
          this.userList = res.data.data[0];
        });
    },
    //最开始获取所有页面数据
    getAllPage() {
      this.$axios
        .get(this.$url_prefix + "getAllInfo", {
          params: {
            date: this.date1,
            start_time: this.start_time,
            end_time: this.end_time,
            input: this.input,
            page: this.chooseIndex
          }
        })
        .then(res => {
          let result = res.data.data;
          this.tableData = result;
        });
    },
    //右侧
    getPage() {
      console.log(this.chooseIndex);
      this.$axios
        .get(this.$url_prefix + "getPageInfo", {
          params: {
            date: this.date1,
            start_time: this.start_time,
            end_time: this.end_time,
            input: this.input,
            page: this.chooseIndex
          }
        })
        .then(res => {
          let result = res.data.data;
          this.tableData = result;
        });
    },
    getDate(time) {
      if (time == "昨日") {
        this.date1 = 1;
        this.isActive = true;
        this.isActive1 = false;
        this.isActive2 = false;
      } else if (time == "七天") {
        this.date1 = 7;
        this.isActive = false;
        this.isActive1 = true;
        this.isActive2 = false;
      } else if (time == "30天") {
        this.date1 = 30;
        this.isActive = false;
        this.isActive1 = false;
        this.isActive2 = true;
      }
      this.start_time = "";
      this.end_time = "";
      if (this.chooseIndex == "") {
        this.getAllPage();
      } else {
        this.getPage();
      }
    },
    // changePage() {
    //   if(this.chooseDate != '') {
    //     this.date1 = ''
    //     this.start_time = this.chooseDate
    //     this.end_time = this.chooseDate
    //   }
    //   this.getPage()
    // },
    select() {
      if (this.input != "") {
        this.getPage();
      }
    },
    handleCellClick(row, column, cell) {
      // 判断点击格子的内容是否为数字,不是数字则return
      this.$open();
      this.isShow = true;
      if (isNaN(cell.innerHTML.match(">(.*?)<")[1])) {
        this.$close();
        return;
      }
      let colPropety = column.property;
      let path = row.page_path;
      console.log(colPropety);
      console.log(path);
      console.log(this.date1);
      console.log(this.allLists.length);
      this.title = row.page_name + " " + column.label;
      if (this.date1 == 7) {
        if (this.allLists.length == 0) {
          this.$close();
          this.$axios.get(this.$url_prefix + "queryPageVisitsDay").then(res => {
            this.allLists = res.data.data;
            this.filterAllList(path, colPropety, row);
          });
        } else {
          this.$close();
          this.filterAllList(path, colPropety, row);
        }
      } else {
        if (this.allLists.length == 0) {
          this.$close();
          this.$axios.get(this.$url_prefix + "queryPageVisits").then(res => {
            this.allLists = res.data.data;
            this.filterAllList(path, colPropety, row);
          });
        } else {
          this.$close();
          this.filterAllList(path, colPropety, row);
        }
      }
    },
    filterAllList(path, Propety) {
      this.dateList = [];
      this.realAllList = [];
      let arr = [...this.allLists];
      this.allLists = [];
      for (let i = 0; i < arr.length; i++) {
        // 时间数组
        let date = arr[i].date.split("-")[1] + "-" + arr[i].date.split("-")[2];
        this.dateList.push(date);
        // 折线数据数组
        let temp = arr[i].data.filter(item => {
          return item.page_path == path;
        });
        this.realAllList.push(temp[0][Propety]);
      }
      this.count();
    },
    sortNumberString(a, b) {
      // 将字符串转换为数字，然后进行比较
      return parseFloat(a.page_staytime_pv) - parseFloat(b.page_staytime_pv);
    },
    selectPic() {
      console.log(this.isShow);
      if (this.isShow == true) {
        this.isShow = false;
        const containerHeight = this.$refs.tableContainer.clientHeight;
        const percentage = 95;
        this.tabelHeight = (containerHeight * percentage) / 100;
      } else if (thia.isShow == false) {
        this.isShow = true;
        const containerHeight = this.$refs.tableContainer.clientHeight;
        const percentage = 60;
        this.tabelHeight = (containerHeight * percentage) / 100;
      }
    }
  }
};
</script>

<style scoped>
.top_title {
  text-align: center;
  line-height: 50px;
  height: 50px;
  border-bottom: 1px solid rgb(168, 165, 165);
}
.aside_top {
  position: relative;
  margin: 10px;
}
.text {
  padding-top: 12px;
  font-size: 18px;
}
.contain {
  display: flex;
}
aside {
  width: 30%;
  margin-left: 1vw;
  margin-top: 1vh;
}
.div_box {
  width: 100%;
  height: 14.5vh;
  background-color: rgb(235, 232, 232);
  border-radius: 8px;
}
.aside_bottom {
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  padding: 5px 10px;
}
.div_text {
  position: relative;
  height: 70px;
  border-radius: 8px;
  width: 100px;
  background-color: #fff;
}
.text_center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  text-align: center;
}
.right_content {
  position: relative;
  width: 70%;
  background-color: rgb(235, 232, 232);
  height: 91vh;
  margin-left: 1vw;
  margin-top: 2vh;
  border-radius: 8px;
  margin-right: 1vw;
  padding-bottom: 2vh;
}
.button {
  width: 100px;
  margin-left: 20px;
}
.echarts {
  margin-top: 20px;
}
.container {
  width: 97%;
  margin-left: 1vw;
  margin-top: 1vh;
  height: 100%;
}
.selectPic {
  position: absolute;
  right: 2vw;
  bottom: 32%;
}
</style>



// WEBPACK FOOTER //
// src/page/getDataInfo.vue